import signedFetch from '../../../apiCalls/util/signedFetch.js';

export const studentDataUrl = orgId =>
  // @ts-ignore
  `${__API_BASE__}/org/${orgId}/student-data`;

export default function* downloadStudentDataApi(orgId) {
  return yield signedFetch('student-data', studentDataUrl(orgId), 'GET');
}
